<div *ngIf="type == 2" class="flex flex-col items-start gap-4 py-4 md:border-bottom bg-white">
    <div class="flex w-full justify-between items-center">
        <div class="flex items-center gap-4">
            <h2 class="text-xl text-black font-bold">فاصله ها و دسترسی ها</h2>
        </div>
        <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex !pe-0" (click)="openModal()">
            <span class="text-blue-500 text-sm !font-medium">مشاهده همه فاصله ها</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
        </button>
    </div>
    <div class="flex justify-between w-full flex-wrap">
        <div class="lg:w-1/2 w-full">
        
            <ul *ngIf="dataSource?.DistanceList?.length" class="mt-3 w-full">
                <ng-container *ngFor="let item of dataSource?.DistanceList;let index = index">
                <li class="grid grid-cols-2 justify-between mt-2 items-center gap-2" *ngIf="index < 2">
                    <div class="flex justify-start items-center">
                        <span class="text-black-300 text-start text-base">{{item.Name}}</span>
                    </div>
                    <p class="font-extralight text-black-300 text-sm text-end">{{ item.Distance }} {{ item.Duration}}</p>
                </li>
                </ng-container>
            </ul>
        </div>
  

    </div>

<button mat-button color="primary" class="icon-arrow-button md:!hidden" (click)="openModal()">
    <span>مشاهده همه فاصله ها</span>
    <i class="ico-Left !text-2xl text-blue-500"></i>
</button>
</div>

<div *ngIf="type != 2" class="flex flex-col items-start gap-4 py-4 md:border-bottom bg-white">
    <div class="flex w-full justify-between items-center">
        <div class="flex items-center gap-4">
            <h2 class="text-xl text-black font-bold">فاصله ها و دسترسی ها</h2>
            <span class="flex gap-4 text-black-300 text-sm">با خودرو</span>
        </div>
        <button mat-button color="primary" class="icon-arrow-button !hidden md:!flex !pe-0" (click)="openModal()">
            <span class="text-blue-500 text-sm !font-medium">مشاهده همه فاصله ها</span>
            <i class="ico-Left !text-2xl text-blue-500"></i>
        </button>
    </div>
    <ng-container *ngIf="dataSource">
        <div class="flex justify-between w-full flex-wrap lg:flex-nowrap gap-4">
            <div class="w-full" *ngIf="dataSource?.MetroLines?.length">
                <!-- ایستگاه‌های مترو -->
                <div class="flex justify-start items-center">
                    <i class="ico-Train text-xl ml-2"></i>
                    <h3 class="text-base font-bold">فاصله تا پایانه ها</h3>
                </div>
                <ul  class="mt-3 w-full">
                    <li *ngFor="let item of dataSource.MetroLines"
                        class="grid grid-cols-2 justify-between mt-2 items-center gap-2">
                        <div class="flex justify-start items-center">
                            <span class="text-black-300 text-start">{{item.Name}}</span>
                        </div>
                        <p class="font-extralight text-black-300 text-sm text-end">{{ item.Distance }} {{
                            item.DistanceUnitName
                            }}</p>
                    </li>
                </ul>
                <ul *ngIf="dataSource?.Airports?.length" class="mt-3 w-full">
                    <li *ngFor="let item of dataSource.Airports"
                        class="grid grid-cols-2 justify-between mt-2 items-center gap-2">
                        <div class="flex justify-start items-center">
                            <span class="text-black-300 text-start">{{item.Name}}</span>
                        </div>
                        <p class="font-extralight text-black-300 text-sm text-end">{{ item.Distance }} {{
                            item.DistanceUnitName }}
                        </p>
                    </li>
                </ul>
            </div>



            <div class="w-full my-3 lg:my-0 lg:px-16  border-b border-solid lg:border-none pb-3"
                *ngIf="nearBies?.length">
                <!-- مکان های نزدیک-->
                <div class="flex justify-start items-center">
                    <i class="ico-Location-line text-xl ml-2"></i>
                    <h3 class="text-base font-bold">مکان های نزدیک</h3>
                </div>
                <ul *ngIf="nearBies?.length" class="mt-3 w-full">
                    <ng-container *ngFor="let item of nearBies;let index = index">
                        <li class="grid grid-cols-2 justify-around mt-2 items-center gap-2" *ngIf="index < 2">
                            <div class="flex justify-start items-center">
                                <span class="text-black-300 text-start">{{item?.Name}}</span>
                            </div>
                            <p class="font-extralight text-black-300 text-sm text-end">{{ item?.Distance }} {{
                                item?.DistanceUnit == 1
                                ? 'متر' : 'کیلومتر' }}
                            </p>
                        </li>
                    </ng-container>

                </ul>
            </div>






            <div class="w-full  pb-3" *ngIf="dataSource?.HolyShrines?.length">
                <!-- مکان های مقدس -->
                <div class="flex justify-start items-center">
                    <i class="ico-Holyshrine text-xl ml-2"></i>
                    <h3 class="text-base font-bold">مکان های مهم دیگر</h3>
                </div>
                <ul *ngIf="dataSource?.HolyShrines?.length" class="mt-3 w-full">
                    <li *ngFor="let item of dataSource?.HolyShrines"
                        class="grid grid-cols-2 justify-between mt-2 items-center gap-2">
                        <div class="flex justify-start items-center">
                            <span class="text-black-300">{{item?.Name}}</span>
                        </div>
                        <p class="font-extralight text-black-300 text-sm text-end">{{ item?.Distance }} {{
                            item?.DistanceUnitName }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>
    </ng-container>


    <button mat-button color="primary" class="icon-arrow-button md:!hidden" (click)="openModal()">
        <span>مشاهده همه فاصله ها</span>
        <i class="ico-Left !text-2xl text-blue-500"></i>
    </button>
</div>